document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('[data-compatible-accessories]');
  if (!wrapper) return;

  const form = document.querySelector('form[is="product-form"]');
  if (!form) return;

  const getSelectedAccessories = () =>
    Array.from(wrapper.querySelectorAll('.compatible-accessories__checkbox:checked')).map(
      (el) => ({ id: Number(el.dataset.variantId), quantity: 1 })
    );

  const addAccessories = async (accessories) => {
    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: accessories }),
      });

      if (!response.ok) {
        const body = await response.json();
        console.error('Compatible accessories add failed:', body.description || response.statusText);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Compatible accessories add failed:', error);
      return false;
    }
  };

  // 使用者按下 Add to cart 的當下就動作，不等主商品的請求先完成，
  // 兩邊各自平行送出，縮短整體等待時間。
  form.addEventListener('submit', function () {
    const accessories = getSelectedAccessories();
    if (accessories.length === 0) return;

    addAccessories(accessories).then((success) => {
      if (success) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });
  });
});